import { NgModule } from "@angular/core";
import { CustomFileSelectDirective } from "./custom-file-select.directive";

@NgModule({
  declarations: [CustomFileSelectDirective],
  exports: [CustomFileSelectDirective]
})
export class CustomUploaderModule {}
